import { isTokenWithUnit } from '../types';

const toKebabCase = (value: string) => value.replaceAll(/[A-Z]/g, (character) => `-${character.toLowerCase()}`);

export const getCssVariables = ({
  object,
  prefix = '--rc-theme',
}: {
  object: object;
  prefix?: string;
}): Array<[string, string]> => {
  const variables: Array<[string, string]> = [];

  for (const [key, value] of Object.entries(object) as Array<[string, unknown]>) {
    const variableName = `${prefix}-${toKebabCase(key)}`;

    if (isTokenWithUnit(value)) {
      variables.push([variableName, `${value.value}${value.unit}`]);
    } else if (typeof value === 'object' && value !== null) {
      variables.push(...getCssVariables({ object: value, prefix: variableName }));
    } else if (typeof value === 'number') {
      variables.push([variableName, value.toString()]);
    } else if (typeof value === 'string') {
      variables.push([variableName, value]);
    } else {
      continue;
    }
  }

  return variables;
};

export const setCssVariables = ({ object, prefix = '--rc-theme' }: { object: object; prefix?: string }) => {
  const root = document.documentElement;

  for (const [name, value] of getCssVariables({ object, prefix })) {
    root.style.setProperty(name, value);
  }
};
